import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styled;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import Select from 'react-select';
import { components } from 'react-select';
import Avatar from "@mui/material/Avatar";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { FormGroup, Input, List, ListItem, TextField, Button, Alert, Checkbox, FormControl } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ExpandIcon from '@mui/icons-material/Expand';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import AvatarEditor from 'react-avatar-editor';
import { countryCodes } from '../app/Utils/CountryCode';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import axios from 'axios';
import '../../../assets/styles.css';
import { fetchSignature, createNewTemplate, updateTemplate, deleteSignature, fetchTweets, fetchInstagramLastPost } from "./AppActions";
import swal from 'sweetalert';
import { Tooltip, Zoom } from '@mui/material';
import '../../../assets/Signature.css';
import 'rc-slider/assets/index.css';
import Progress from './components/progress';
import ScrollableTabsButtonAuto from './components/ScrollableTabsButtonAuto';
import StandardImageList from './components/StandardImageList';
import SelectFontFamily from './components/SelectFontFamily';
import previewTemplate1 from '../../../assets/images/preview/1.png';
import previewTemplate2 from '../../../assets/images/preview/1b.png';
import previewTemplate3 from '../../../assets/images/preview/2.png';
import previewTemplate4 from '../../../assets/images/preview/4.png';
import previewTemplate5 from '../../../assets/images/preview/5.png';
import previewTemplate6 from '../../../assets/images/preview/6.png';
import previewTemplate7 from '../../../assets/images/preview/6.png';
import previewTemplate8 from '../../../assets/images/preview/6.png';
import nameTooltip from '../../../assets/images/tooltip/nameTooltip.jpg';
import titleTooltip from '../../../assets/images/tooltip/titleTooltip.jpg';
import addressTooltip from '../../../assets/images/tooltip/addressTooltip.jpg';
import closeCircleImg from '../../../assets/images/close-circle.svg';
import Template from './Template';
import { isMobile } from "react-device-detect";
import { dispatch } from 'rxjs/internal/observable/pairs';

var hiddenElementStyle = {
    "border": "0",
    "clip": "rect(0 0 0 0)",
    "height": "1px",
    "margin": "-1px",
    "overflow": "hidden",
    "padding": "0",
    "position": "absolute",
    "whiteSpace": "nowrap"
};

var options = [''];

var Main = styled('div')({
    backgroundColor: '#fff',
    height: '100vh'
});

var Header = styled('div')({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    color: '#1F6BF1',
    backgroundColor: '#fff',
    fontWeight: 500,
    padding: '0'
});

var UserData = styled('div')({
    color: '#000',
    backgroundColor: 'white',
    borderRadius: 4
});

var Preview = styled('div')((_styled = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1.37903px solid #bdbdbd',
    borderRadius: '11.8952px',
    color: '#1F6BF1',
    backgroundColor: '#fff'
}, _defineProperty(_styled, 'borderRadius', 4), _defineProperty(_styled, 'margin', '25px 20px'), _defineProperty(_styled, '@media only screen and (max-width: 767px)', {
    margin: '20px 30px',
    overflow: 'auto'
}), _defineProperty(_styled, '@media only screen and (max-width: 474px)', {
    margin: '25px 10px'
}), _styled));

var AlignForm = styled('div')({
    margin: '25px 20px',
    '@media only screen and (max-width: 767px)': {
        margin: '25px 30px'
    },
    '@media only screen and (max-width: 474px)': {
        margin: '25px 10px'
    }
});

var AlignContent = styled('div')({
    paddingTop: '1px',
    paddingBottom: '1px'
});

var Hide = styled('div')({
    display: 'none'
});

var Design = styled('div')({
    margin: '0 40px',
    width: '100%',
    '@media only screen and (max-width: 767px)': {
        margin: '0 30px 10px'
    }
});

var DropdownIndicator = function DropdownIndicator(props) {
    return React.createElement(
        components.DropdownIndicator,
        props,
        props.selectProps.menuIsOpen ? React.createElement(
            'span',
            { style: { fontSize: '13px', padding: '0 5px', color: '#1F6BF1' } },
            '\u25B2'
        ) : React.createElement(
            'span',
            { style: { fontSize: '13px', padding: '0 5px', color: '#1F6BF1' } },
            '\u25BC'
        )
    );
};

var testMode = false;

var Signature = function (_Component) {
    _inherits(Signature, _Component);

    function Signature(props) {
        var _this2 = this;

        _classCallCheck(this, Signature);

        var _this = _possibleConstructorReturn(this, (Signature.__proto__ || Object.getPrototypeOf(Signature)).call(this, props));

        _this.fetchCountryCode = function () {
            axios.get('https://reg3.bluemailapp.com/country_code').then(function (response) {
                var countryCode = response.data.toUpperCase();
                _this.setState({ countryCode: countryCode });
                var countryObject = countryCodes.find(function (country) {
                    return country.code === countryCode;
                });
                if (countryObject) {
                    var phoneCode = countryObject.phoneCode;
                    _this.setState({ phoneCode: phoneCode });
                } else {
                    console.error('Country code not found in the countryCodes array.');
                }
            }).catch(function (error) {
                console.error('Error fetching country code:', error);
            });
        };

        _this.getInitialFields = function () {
            return {
                name: '',
                title: '',
                phone: '',
                mobile: '',
                telephone: '',
                fax: '',
                website: '',
                email: '',
                skype: '',
                address: '',
                picture_link: '',
                whatsapp: '',
                countryCode: '',
                phoneCode: '',
                facebook: '',
                size: '',
                selectedTemplateColor: '',
                selectedColor: '',
                selectedColorName: '',
                selectedColorTitle: '',
                selectedColorAddress: '',
                selectedColorDivider: '',
                fontSize: '',
                fontSizeName: '',
                fontSizeAddress: '',
                fontSizeTitle: '',
                fontLineHeightName: '',
                addressTextOpacity: '',
                fontLineHeightTitle: '',
                fontWeightName: '',
                fontWeightTitle: '',
                fontStyleName: '',
                fontStyleTitle: '',
                activeFontFamily: '',
                currentIndex: '',
                linkedin: '',
                quote: '',
                checkSignature: '',
                twitter: '',
                twitterLink: '',
                instagram: '',
                instagramLink: '',
                tiktok: '',
                twitterData: '',
                instagramData: '',
                youtube: '',
                github: '',
                google: '',
                fontFamily: '',
                color: {},
                picture_base64: '',
                banner_base64: '',
                file_name: '',
                template: '',
                backgroundColor: {},
                apps: {
                    modal: false,
                    current: '',
                    currentTitle: '',
                    disclaimer: {
                        text: '',
                        active: false
                    },
                    youtube: {
                        link: '',
                        thumbnail: '',
                        active: false,
                        thumbnailBase64: '',
                        embed: '',
                        example: ''
                    }
                }
            };
        };

        _this.handleChange = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                var change, fileInput, _fileInput, _fileInput2, allowedExtensions, fileExtension, _fileInput3, _fileInput4, resizedImage, val;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                change = { values: _this.state.values };

                                // if new user

                                if (_this.state.phoneCode && change.values.phoneCode === '') {
                                    change.values.phoneCode = _this.state.phoneCode;
                                }

                                if (change.values.phoneCode === undefined) {
                                    change.values.phoneCode = _this.state.phoneCode;
                                }

                                if (!(!e || !e.type)) {
                                    _context.next = 8;
                                    break;
                                }

                                _this.setState({
                                    imgFormat: true
                                });
                                fileInput = document.getElementById("file-input-image");

                                if (fileInput) {
                                    fileInput.value = "";
                                }
                                return _context.abrupt('return');

                            case 8:
                                if (!(e && e.type && e.type === "removePicture")) {
                                    _context.next = 15;
                                    break;
                                }

                                // Clear the picture data and file name
                                change.values.picture_base64 = '';
                                change.values.file_name = '';
                                _fileInput = document.getElementById("file-input-image");

                                if (_fileInput) {
                                    _fileInput.value = '';
                                }
                                _context.next = 45;
                                break;

                            case 15:
                                if (!(e && e.type && e.type.startsWith("application/") || e && e.type && e.type.startsWith("video/") || e && e.type && e.type.startsWith("text/"))) {
                                    _context.next = 22;
                                    break;
                                }

                                _this.setState({
                                    imgFormat: true
                                });
                                _fileInput2 = document.getElementById("file-input-image");

                                if (_fileInput2) {
                                    _fileInput2.value = "";
                                }
                                return _context.abrupt('return');

                            case 22:
                                if (!(e && e.type && e.type.startsWith("image/"))) {
                                    _context.next = 44;
                                    break;
                                }

                                // Check if the image type is not PNG, JPG, or JPEG
                                allowedExtensions = ["png", "jpeg", "jpg"];
                                fileExtension = e.name.split(".").pop().toLowerCase();

                                if (allowedExtensions.includes(fileExtension)) {
                                    _context.next = 30;
                                    break;
                                }

                                // Show error and clear the input
                                _this.setState({
                                    imgFormat: true
                                });
                                _fileInput3 = document.getElementById("file-input-image");

                                if (_fileInput3) {
                                    _fileInput3.value = "";
                                }
                                return _context.abrupt('return');

                            case 30:
                                if (!(e.size > 2000000)) {
                                    _context.next = 37;
                                    break;
                                }

                                _this.setState({
                                    imgSize: true
                                });
                                _fileInput4 = document.getElementById("file-input-image");

                                if (_fileInput4) {
                                    _fileInput4.value = '';
                                }
                                return _context.abrupt('return');

                            case 37:
                                _context.next = 39;
                                return _this.resizeImage(e);

                            case 39:
                                resizedImage = _context.sent;

                                change.values.picture_base64 = resizedImage.dataURL;
                                change.values.file_name = resizedImage.fileName;

                            case 42:
                                _context.next = 45;
                                break;

                            case 44:
                                if (e && e.target) {
                                    // Handle other input changes
                                    val = void 0;

                                    if (e.target.hasOwnProperty('checked')) {
                                        val = e.target.checked && _this.state.values.mobile ? true : false;
                                    } else {
                                        val = e.target.value;
                                    }
                                    change.values[e.target.name] = val;

                                    if (e.target.name === 'email') {
                                        _this.validateEmail();
                                    }
                                    if (e.target.name === 'website' || e.target.name === 'picture_link') {
                                        _this.validateURL();
                                    }
                                }

                            case 45:
                                _this.setState(change);

                                if (_this.state.values.phoneCode.length < 2) {
                                    _this.setState({ countryCodeTooltip: true });
                                } else {
                                    _this.setState({ countryCodeTooltip: false });
                                }
                                if (_this.state.values.phoneCode.length < 1) {
                                    _this.setState({ phoneCode: '' });
                                }

                            case 48:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.resizeImage = function (image) {
            return new Promise(function (resolve, reject) {
                var MAX_SIZE = 200 * 1024; // 200 KB
                var MAX_WIDTH = 254; // Adjust as needed

                var img = new Image();
                img.onload = function () {
                    var width = img.width;
                    var height = img.height;

                    if (image.size > MAX_SIZE || width > MAX_WIDTH) {
                        var scaleFactor = Math.max(image.size / MAX_SIZE, width / MAX_WIDTH);
                        width = Math.floor(width / scaleFactor);
                        height = Math.floor(height / scaleFactor);
                    }

                    var canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;

                    var ctx = canvas.getContext('2d');

                    // Set a specific interpolation method for better quality
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';

                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(function (blob) {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            resolve({
                                dataURL: reader.result,
                                fileName: image.name
                            });
                        };
                        reader.readAsDataURL(blob);
                    }, image.type, 0.9 // Adjust compression quality (0.0 - 1.0)
                    );
                };

                img.onerror = function () {
                    reject(new Error('Failed to load image'));
                };

                img.src = URL.createObjectURL(image);
            });
        };

        _this.showPreviewMobile = function () {
            if (window.innerWidth < 991) {
                _this.setState(function (prevState) {
                    return { isShowingPreviewMobile: !prevState.isShowingPreviewMobile };
                });
            }
        };

        _this.handleCheck = function () {
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        checkSignature: !prevState.values.checkSignature
                    })
                };
            });
        };

        _this.remAlert = function () {
            _this.setState({
                imgFormat: false,
                imgSize: false,
                scale: 1
            });
            if (_this.state.validImageURLAlert) {
                _this.setState({
                    validImageURLAlert: false,
                    values: Object.assign({}, _this.state.values, {
                        picture_link: '' // Set picture_base64 to an empty string
                    })
                });
            }
        };

        _this.handleItemClick = function (newTab) {
            _this.setState({ selectedTabValue: newTab });
        };

        _this.addNewTemplate = function () {
            _this.setState({
                setDefaults: true,
                newTemplate: true,
                templates: false,
                savedValue: _this.state.value,
                savedFields: _this.state.values,
                countryCodeTooltip: false,
                value: '',
                templateName: '',
                imgFormat: false,
                values: Object.assign({}, _this.getInitialFields(), {
                    email: _this.state.email ? _this.state.email : '',
                    fontSizeName: '15',
                    fontSizeTitle: '14',
                    fontSizeAddress: '13',
                    fontSize: '12',
                    checkSignature: true,
                    fontStyleName: 'normal',
                    fontStyleTitle: 'normal',
                    fontWeightName: '400',
                    fontWeightTitle: '400'
                }),
                checkSignature: true,
                onCreate: true,
                activeFontFamily: '',
                fontStyleName: 'normal',
                fontStyleTitle: 'normal',
                fontWeightName: '400',
                fontWeightTitle: '400',
                selectedTabValue: 0
            });
            _this.fetchCountryCode();
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        phoneCode: _this.state.phoneCode
                    })
                };
            });
        };

        _this.cancelAddNewTemplate = function () {
            _this.setState({
                setDefaults: false,
                newTemplate: false,
                templates: true,
                value: _this.state.savedValue,
                values: _this.state.savedFields,
                fontStyleName: _this.state.savedFields.fontStyleName,
                fontStyleTitle: _this.state.savedFields.fontStyleTitle,
                fontWeightName: _this.state.savedFields.fontWeightName,
                fontWeightTitle: _this.state.savedFields.fontWeightTitle
            });
            if (_this.state.savedFields.phoneCode.length < 2) {
                _this.setState({ countryCodeTooltip: true });
            }
        };

        _this.handleColorTemplateChange = function (event) {
            var selectedTemplateColor = event.target.value;
            _this.setState({ selectedTemplateColor: selectedTemplateColor });
            _this.state.values.selectedTemplateColor = selectedTemplateColor;
        };

        _this.handleColorChangeName = function (event) {
            var selectedColorName = event.target.value;
            _this.setState({ selectedColorName: selectedColorName });
            _this.state.values.selectedColorName = selectedColorName;
        };

        _this.handleColorChangeTitle = function (event) {
            var selectedColorTitle = event.target.value;
            _this.setState({ selectedColorTitle: selectedColorTitle });
            _this.state.values.selectedColorTitle = selectedColorTitle;
        };

        _this.handleColorChangeAddress = function (event) {
            var selectedColorAddress = event.target.value;
            _this.setState({ selectedColorAddress: selectedColorAddress });
            _this.state.values.selectedColorAddress = selectedColorAddress;
        };

        _this.handleColorChangeDivider = function (event) {
            var selectedColorDivider = event.target.value;
            _this.setState({ selectedColorDivider: selectedColorDivider });
            _this.state.values.selectedColorDivider = selectedColorDivider;
        };

        _this.handleColorChange = function (event) {
            var selectedColor = event.target.value;
            _this.setState({ selectedColor: selectedColor });
            _this.state.values.selectedColor = selectedColor;
        };

        _this.handleScaleChange = function (e) {
            var scale = parseFloat(e.target.value);
            _this.setState({ scale: scale });
        };

        _this.handleSetNewValue = function () {
            var change = { values: _this.state.values };
            var imageEditor = _this.editorRef.getImageScaledToCanvas().toDataURL();

            // Check if a crop has been performed
            if (imageEditor !== _this.state.values.picture_base64) {
                _this.setState(function (prevState) {
                    return {
                        values: Object.assign({}, prevState.values, {
                            picture_base64: imageEditor
                        })
                    };
                });
            }

            change['values']['picture_base64'] = imageEditor;

            _this.setState({ scale: 1 });
        };

        _this.selectTemplate = function (id) {
            var selectedTemplate = id.toString();
            _this.setState({ selectedTemplate: selectedTemplate, currentIndex: selectedTemplate });
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        currentIndex: selectedTemplate
                    })
                };
            }, function () {
                // Now, you can safely call templateChange after the state has been updated
                _this.templateChange(selectedTemplate);
            });
        };

        _this.handleFontChange = function (selectedFont) {
            _this.setState({ activeFontFamily: selectedFont });
        };

        _this.toggleMenu = function () {
            _this.setState(function (prevState) {
                return {
                    isMenuOpen: !prevState.isMenuOpen
                };
            });
        };

        _this.handleFontWeightChange = function (event) {
            var fontWeightName = event.target.value;
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        fontWeightName: fontWeightName
                    })
                };
            });
        };

        _this.handleFontWeightChangeTitle = function (event) {
            var fontWeightTitle = event.target.value;
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        fontWeightTitle: fontWeightTitle
                    })
                };
            });
        };

        _this.handleFontStyleChange = function (event) {
            var fontStyleName = event.target.value;
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        fontStyleName: fontStyleName
                    })
                };
            });
        };

        _this.handleFontStyleChangeTitle = function (event) {
            var fontStyleTitle = event.target.value;
            _this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        fontStyleTitle: fontStyleTitle
                    })
                };
            });
        };

        _this.toggleAddressVisibility = function () {
            _this.setState(function (prevState) {
                return {
                    isAddressVisible: !prevState.isAddressVisible,
                    isTitleVisible: false,
                    isNameVisible: false
                };
            });
        };

        _this.toggleTitleVisibility = function () {
            _this.setState(function (prevState) {
                return {
                    isAddressVisible: false,
                    isTitleVisible: !prevState.isTitleVisible,
                    isNameVisible: false
                };
            });
        };

        _this.toggleNameVisibility = function () {
            _this.setState(function (prevState) {
                return {
                    isAddressVisible: false,
                    isTitleVisible: false,
                    isNameVisible: !prevState.isNameVisible
                };
            });
        };

        _this.wrapperDiv = React.createRef();
        _this.formRef = React.createRef();
        _this.state = _this.getInitialValues(), _this.selectTemplate = _this.selectTemplate.bind(_this);
        _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        return _this;
    }

    _createClass(Signature, [{
        key: 'templateLoadingText',
        value: function templateLoadingText() {
            var _this3 = this;

            this.setState({
                loadingTemplate: true
            });
            setTimeout(function () {
                _this3.setState({
                    loadingTemplate: false
                });
            }, 5000);
        }
    }, {
        key: 'getData',
        value: function getData() {
            var _this4 = this;

            var x = 'sebastian.m@inlabs.me'; // just dev
            var user = this.props.user; // just prod        

            axios.get('/api/signature' + '?email=' + (testMode ? x : user.email)).then(function (response) {
                _this4.setState({
                    allSig: response.data.signatures,
                    templates: true,
                    value: response.data.signatures[0].id,
                    email: testMode ? x : user.email
                });
                console.log(_this4.state.allSig, "fetch all");
                setTimeout(function () {
                    _this4.setState({
                        loadingTemplate: false
                    });
                }, 3000);
            }).then(function () {
                _this4.fetchNewSignature();
            }).catch(function (err) {
                _this4.setState({
                    noUserData: true
                });
            });
        }
    }, {
        key: 'setDefStates',
        value: function setDefStates() {
            this.setState({
                newTemplate: false,
                activeItem: 'Info',
                selectedTabValue: 0,
                isNameVisible: true
            });
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var user, x;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                user = this.props.user;
                                x = 'sebastian.m@inlabs.me'; // just dev        

                                this.getData();
                                this.setDefStates();
                                this.templateLoadingText();
                                this.props.fetchSignature(testMode ? x : user.email);
                                this.updateWindowDimensions();
                                window.addEventListener('resize', this.updateWindowDimensions);
                                document.addEventListener('click', this.handleOutsideClick);
                                this.fetchCountryCode();
                                this.setDefaultColor();

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidMount() {
                return _ref2.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {

            if (this.props.initialValues !== prevProps.initialValues) {
                var values = this.state.onCreate ? this.state.values : this.props.initialValues;
                this.setState({ values: values });
            }

            if (prevState.allSig !== this.state.allSig || prevState.value !== this.state.value) {
                this.setIndex();
            }
        }
    }, {
        key: 'findIndexById',
        value: function findIndexById(arr, targetId) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id === targetId) {
                    return i;
                }
            }
            return -1;
        }
    }, {
        key: 'setIndex',
        value: function setIndex() {
            if (Array.isArray(this.state.allSig)) {
                var targetId = this.state.value;
                var index = this.findIndexById(this.state.allSig, targetId);
                this.setState({ selectorIndex: index });
            } else {
                console.log('not array or is undefined.');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.updateWindowDimensions);
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }, {
        key: 'updateWindowDimensions',
        value: function updateWindowDimensions() {
            this.setState({ width: window.innerWidth, height: window.innerHeight });
        }
    }, {
        key: 'fetchNewSignature',
        value: function fetchNewSignature() {
            var id = this.state.value;
            var _props = this.props,
                user = _props.user,
                fetchSignature = _props.fetchSignature;

            this.setState({
                activeFontFamily: undefined,
                countryCodeTooltip: false
            });
            var x = 'sebastian.m@inlabs.me'; // just dev   
            testMode ? fetchSignature(x, id) : fetchSignature(user.email, id);
        }
    }, {
        key: 'createNewTemplate',
        value: function createNewTemplate() {
            var x = "sebastian.m@inlabs.me"; // just dev
            var setId = this.state.allSig === undefined ? 0 : this.state.allSig.slice(-1)[0].id + 1;
            var metadata = { defaultSignature: setId };
            var id = setId;
            var name = this.state.templateName ? this.state.templateName : '';
            var isDefault = false;
            var source = 'template';
            var templateId = setId;
            var noPrevSig = this.state.noUserData;
            var _props2 = this.props,
                user = _props2.user,
                createNewTemplate = _props2.createNewTemplate,
                fetching = _props2.fetching,
                fetchingTweets = _props2.fetchingTweets,
                fetchingInstagram = _props2.fetchingInstagram;

            var values = Object.assign({}, this.state.values);
            var currentContent = document.getElementById('signature').innerHTML;

            var createdSignature = [{ id: id, isDefault: isDefault, name: name, source: source, signature: currentContent, fields: this.state.values, templateId: templateId, noPrevSig: noPrevSig }];
            var dataToSave = !noPrevSig ? [].concat(_toConsumableArray(this.state.allSig), createdSignature) : createdSignature;

            if (fetching === true || fetchingTweets === true || fetchingInstagram === true) {
                values.fetchingError = true;
                this.setState({ values: values });
            } else {
                testMode ? createNewTemplate(x, metadata, dataToSave) : createNewTemplate(user.email, metadata, dataToSave);
                this.setState({
                    allSig: dataToSave,
                    value: id,
                    newTemplate: false,
                    templates: true,
                    noUserData: false,
                    setDefaults: false
                });
            }
        }
    }, {
        key: 'updateTemplate',
        value: function updateTemplate() {
            var _this5 = this;

            var x = "sebastian.m@inlabs.me"; // just dev
            var setId = this.state.allSig === undefined ? 0 : this.state.allSig.slice(-1)[0].id + 1;
            var selectedOption = this.state.allSig.find(function (d) {
                return d.id === _this5.state.value;
            });
            var text = selectedOption ? selectedOption.name : '';
            var toDelete = this.state.value;
            var metadata = { defaultSignature: toDelete };
            var id = setId;
            var isDefault = selectedOption ? selectedOption.isDefault : false;
            var name = text;
            var source = 'template';
            var templateId = setId;
            var _props3 = this.props,
                user = _props3.user,
                updateTemplate = _props3.updateTemplate,
                fetching = _props3.fetching,
                fetchingTweets = _props3.fetchingTweets,
                fetchingInstagram = _props3.fetchingInstagram;

            var values = Object.assign({}, this.state.values);
            var currentContent = document.getElementById('signature').innerHTML;
            var updatedSignature = [{ id: id, isDefault: isDefault, name: name, source: source, signature: currentContent, fields: this.state.values, templateId: templateId }];
            var newData = [].concat(_toConsumableArray(this.state.allSig), updatedSignature);
            var dataToSave = newData.filter(function (rec) {
                return rec.id != toDelete;
            });

            if (fetching === true || fetchingTweets === true || fetchingInstagram === true) {
                values.fetchingError = true;
                this.setState({ values: values });
            } else {
                testMode ? updateTemplate(x, metadata, dataToSave) : updateTemplate(user.email, metadata, dataToSave);
                this.setState({
                    allSig: dataToSave,
                    value: id,
                    imgFormat: false
                });
            }
        }
    }, {
        key: 'deleteData',
        value: function deleteData() {
            var _this6 = this;

            this.setState({
                isMenuOpen: false
            });
            swal({
                title: "Are you sure?",
                text: "Once deleted, all data will be lost!",
                icon: "warning",
                buttons: true,
                dangerMode: true
            }).then(function (result) {
                if (result) {
                    var x = 'sebastian.m@inlabs.me'; // just dev
                    var toDelete = _this6.state.value;
                    var _props4 = _this6.props,
                        user = _props4.user,
                        _deleteSignature = _props4.deleteSignature;

                    var metadata = { defaultSignature: _this6.state.value };
                    var dataToSave = _this6.state.allSig.filter(function (rec) {
                        return rec.id != toDelete;
                    });
                    testMode ? _deleteSignature(x, metadata, dataToSave) : _deleteSignature(user.email, metadata, dataToSave);
                    _this6.setState({
                        allSig: dataToSave,
                        value: dataToSave[0].id
                    });
                    _this6.fetchNewSignature();
                }
            });
        }
    }, {
        key: 'getInitialValues',
        value: function getInitialValues() {
            var _ref3;

            var components = {
                1: previewTemplate1,
                2: previewTemplate2,
                3: previewTemplate3,
                4: previewTemplate4,
                5: previewTemplate5,
                6: previewTemplate6,
                7: previewTemplate7,
                8: previewTemplate8
            };

            return _ref3 = {
                values: this.getInitialFields(),
                signature: {
                    initialValue: '',
                    onSave: this.createNewTemplate.bind(this) ? this.createNewTemplate.bind(this) : this.updateTemplate.bind(this),
                    toolbar: { image: true }
                },
                template: '',
                htmlToExport: '',
                copied: false,
                initialValuesLoaded: false,
                selectedTemplate: '0',
                activeItem: 'Info',
                selectedTabValue: 0,
                validEmail: false,
                validWebsiteURL: false,
                handleChange: '',
                validImageURL: false,
                // currentIndex: '1',
                fetchingError: false,
                itemsInSlide: 1,
                templateItems: [1, 2, 3, 4, 5, 6, 7, 8].map(function (item, i) {
                    return React.createElement(
                        'div',
                        null,
                        React.createElement('img', { style: { maxWidth: '170px' },
                            src: components[item]
                        })
                    );
                })

            }, _defineProperty(_ref3, 'itemsInSlide', 3), _defineProperty(_ref3, 'isShowingPreviewMobile', false), _ref3;
        }
    }, {
        key: 'removePicture',
        value: function removePicture() {
            this.handleChange({ type: 'removePicture' });
            this.setState({ imgFormat: false }), this.setState({ imgSize: false });
        }
    }, {
        key: 'templateChange',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
                var values, currentContent;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                values = this.state;

                                values['selectedTemplate'] = value;
                                currentContent = document.getElementById('signature').innerHTML;

                                values['htmlToExport'] = currentContent;
                                this.setState(values);
                                // this.setState({currentIndex: values.selectedTemplate})
                                if (this.state.setDefaults) {
                                    this.setDefaultColor();
                                }

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function templateChange(_x2) {
                return _ref4.apply(this, arguments);
            }

            return templateChange;
        }()
    }, {
        key: 'toDataURL',
        value: function toDataURL(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail() {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (this.state.values.email) {
                this.setState({ validEmail: !re.test(String(this.state.values.email).toLowerCase()) });
            } else {
                this.setState({ validEmail: false });
            }
        }
    }, {
        key: 'validateURL',
        value: function validateURL() {
            var _this7 = this;

            var re = /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)/g;
            var reimg = /\bhttps?:\/\/\S*?\/[^\/.]+\.(jpg|png|jpeg|svg)\b/g;
            if (this.state.values.website && re.test(String(this.state.values.website).toLowerCase()) === true) {
                this.setState({ validWebsiteURL: false });
            } else if (this.state.values.website && re.test(String(this.state.values.website).toLowerCase()) === false) {
                this.setState({ validWebsiteURL: true });
            } else if (!this.state.values.website) {
                this.setState({ validWebsiteURL: false });
            }
            if (this.state.values.picture_link && reimg.test(String(this.state.values.picture_link).toLowerCase()) === true) {
                this.setState({ validImageURL: false, validImageURLAlert: false });
            } else if (this.state.values.picture_link && reimg.test(String(this.state.values.picture_link).toLowerCase()) === false) {
                this.setState({ validImageURL: true });
                setTimeout(function () {
                    _this7.setState({
                        validImageURLAlert: true
                    });
                }, 2500);
                setTimeout(function () {
                    if (_this7.state.validImageURLAlert) {
                        _this7.setState({
                            validImageURLAlert: false,
                            values: Object.assign({}, _this7.state.values, {
                                picture_link: '' // Set picture_base64 to an empty string
                            })
                        });
                    }
                }, 5000);
            } else if (!this.state.values.picture_link) {
                this.setState({ validImageURL: false, validImageURLAlert: false });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _this8 = this;

            this.setState({
                onCreate: false,
                value: e.target.value
            });
            setTimeout(function () {
                _this8.fetchNewSignature();
            }, 0.500);
        }
    }, {
        key: 'onCreateTemplate',
        value: function onCreateTemplate(e) {
            this.fetchCountryCode();
            this.setState({
                templateName: e.target.value,
                setDefaults: true
            });
        }
    }, {
        key: 'renderColorTemplatePicker',
        value: function renderColorTemplatePicker() {
            return React.createElement('input', {
                type: 'color',
                value: this.state.values.selectedTemplateColor ? this.state.values.selectedTemplateColor : '#000000',
                id: 'selectTemplateColor',
                onChange: this.handleColorTemplateChange });
        }
    }, {
        key: 'renderColorPicker',
        value: function renderColorPicker() {
            return React.createElement('input', {
                type: 'color',
                id: 'selectColor',
                value: this.state.values.selectedColor ? this.state.values.selectedColor : '#000000',
                onChange: this.handleColorChange });
        }
    }, {
        key: 'renderColorPickerName',
        value: function renderColorPickerName() {
            return React.createElement('input', {
                type: 'color',
                id: 'selectColorName',
                value: this.state.values.selectedColorName ? this.state.values.selectedColorName : '#000000',
                onChange: this.handleColorChangeName });
        }
    }, {
        key: 'renderColorPickerTitle',
        value: function renderColorPickerTitle() {
            return React.createElement('input', {
                type: 'color',
                id: 'selectColorTitle',
                value: this.state.values.selectedColorTitle ? this.state.values.selectedColorTitle : '#000000',
                onChange: this.handleColorChangeTitle });
        }
    }, {
        key: 'renderColorPickerAddress',
        value: function renderColorPickerAddress() {
            return React.createElement('input', {
                type: 'color',
                id: 'selectColorAddress',
                value: this.state.values.selectedColorAddress ? this.state.values.selectedColorAddress : '#000000',
                onChange: this.handleColorChangeAddress });
        }
    }, {
        key: 'renderColorPickerDivider',
        value: function renderColorPickerDivider() {
            return React.createElement('input', {
                type: 'color',
                id: 'selectColorDivider',
                value: this.state.values.selectedColorDivider ? this.state.values.selectedColorDivider : '#000000',
                onChange: this.handleColorChangeDivider });
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(event) {
            var _event$target = event.target,
                name = _event$target.name,
                value = _event$target.value;

            var prevVal = this.state.values[name];

            // Check if the input value consists of only digits and a plus sign
            if (/^(\+)?\d*$/.test(value)) {
                this.setState(function (prevState) {
                    return {
                        values: Object.assign({}, prevState.values, _defineProperty({}, name, value))
                    };
                });
            } else {
                event.target.value = prevVal; // Revert to the previous value
            }

            if (name === 'phoneCode') {
                if (value.length === 0) {
                    event.target.value = '+'; // If input is empty, set it to '+'
                } else if (value.charAt(0) !== '+') {
                    event.target.value = '+' + value; // If input doesn't start with '+', add it
                }
            }
        }
    }, {
        key: 'handleOutsideClick',
        value: function handleOutsideClick(event) {
            var menu = document.querySelector('.dropdown-menu');
            var icon = document.querySelector('.more-icon');
            if (menu && !menu.contains(event.target) && !icon.contains(event.target)) {
                this.setState({ isMenuOpen: false });
            }
        }
    }, {
        key: 'setDefaultColor',
        value: function setDefaultColor() {
            var _this9 = this;

            var defaultColor = '#4a72c8';

            switch (this.state.selectedTemplate) {
                case "0":
                    defaultColor = '#4a72c8';
                    break;
                case "1":
                    defaultColor = '#bd5f92';
                    break;
                case "2":
                    defaultColor = '#7e4cbe';
                    break;
                case "3":
                    defaultColor = '#42d435';
                    break;
                case "4":
                    defaultColor = '#5c8590';
                    break;
                case "5":
                    defaultColor = '#0d9ad7';
                    break;
                case "6":
                    defaultColor = '#b61919';
                    break;
                case "7":
                    defaultColor = '#247bff';
                    break;
            }

            this.setState(function (prevState) {
                return {
                    values: Object.assign({}, prevState.values, {
                        //color
                        selectedColorName: defaultColor,
                        selectedColorTitle: _this9.state.selectedTemplate === '0' || _this9.state.selectedTemplate === '3' || _this9.state.selectedTemplate === '5' ? '#000000' : defaultColor,
                        selectedColorAddress: _this9.state.selectedTemplate === '0' || _this9.state.selectedTemplate === '1' || _this9.state.selectedTemplate === '3' || _this9.state.selectedTemplate === '5' ? '#000000' : defaultColor,
                        selectedTemplateColor: _this9.state.selectedTemplate === '3' ? '#000000' : defaultColor,
                        selectedColor: _this9.state.selectedTemplate === '0' || _this9.state.selectedTemplate === '1' || _this9.state.selectedTemplate === '3' || _this9.state.selectedTemplate === '5' ? '#000000' : _this9.state.selectedTemplate === '6' ? '#66b5ce' : _this9.state.selectedTemplate === '7' ? "#496ea7" : defaultColor,
                        selectedColorDivider: _this9.state.selectedTemplate === '1' ? '#2dd280' : _this9.state.selectedTemplate === '2' ? '#e5c18a' : defaultColor,
                        // weight
                        fontWeightName: _this9.state.selectedTemplate === '5' ? "" : "700",
                        //opacity
                        addressTextOpacity: 0.4
                    }),
                    fontWeightName: '700',
                    //opacity
                    addressTextOpacity: 0.4
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this10 = this;

            var _props5 = this.props,
                fetching = _props5.fetching,
                fetchingTweets = _props5.fetchingTweets,
                fetchingInstagram = _props5.fetchingInstagram,
                noSignature = _props5.noSignature;
            var _state = this.state,
                values = _state.values,
                isShowingPreviewMobile = _state.isShowingPreviewMobile,
                selectedTabValue = _state.selectedTabValue,
                currentIndex = _state.currentIndex,
                isMenuOpen = _state.isMenuOpen;


            console.log(this.state, "----------");

            if (fetching) {
                return React.createElement(Progress, null);
            } else {

                return (
                    // Nav left for dev tests
                    // <Main style={this.state.width > 1280 ? {marginLeft: '256px', borderLeft: '2px solid red'} : {marginLeft: '0', borderLeft: '0px solid red'}}>
                    React.createElement(
                        Main,
                        { id: 'main-signature' },
                        React.createElement(
                            Grid,
                            { container: true, item: true, lg: 12, md: 12, sm: 12, xs: 12 },
                            React.createElement(
                                Header,
                                null,
                                React.createElement(
                                    Grid,
                                    { item: true, lg: 12, md: 12, xs: 12 },
                                    React.createElement(
                                        AlignContent,
                                        null,
                                        React.createElement(
                                            AlignForm,
                                            null,
                                            React.createElement(
                                                Grid,
                                                { item: true, lg: 6, md: 12, xs: 12, id: 'select-zone', style: { maxWidth: '100%' } },
                                                this.state.allSig === undefined && !this.state.noUserData ? React.createElement(
                                                    Grid,
                                                    { item: true, lg: 6, md: 12, xs: 12, style: { marginBottom: '20px' } },
                                                    this.state.loadingTemplate && React.createElement(
                                                        Grid,
                                                        { item: true, lg: 12, md: 12, xs: 12 },
                                                        React.createElement(
                                                            Alert,
                                                            { severity: 'info' },
                                                            'Loading available signatures... Please wait.'
                                                        )
                                                    )
                                                ) : React.createElement(
                                                    FormGroup,
                                                    null,
                                                    this.state.templates && React.createElement(
                                                        Grid,
                                                        { item: true, container: true, direction: 'row', lg: 12, md: 12, sm: 12, xs: 12, style: { display: 'flex', alignItems: 'center' } },
                                                        React.createElement(
                                                            'div',
                                                            { style: { marginRight: '10px', marginTop: '10px' } },
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, style: { display: 'flex', justifyContent: 'left' } },
                                                                React.createElement(
                                                                    FormControl,
                                                                    null,
                                                                    React.createElement(Select, {
                                                                        isSearchable: false,
                                                                        isClearable: false,
                                                                        isDisabled: false,
                                                                        id: 'tempName',
                                                                        value: this.state.value || this.state.value === undefined || !this.state.value ? {
                                                                            value: this.state.value ? this.state.value : '0',
                                                                            label: this.state.allSig ? this.state.allSig.find(function (d) {
                                                                                return d.id === _this10.state.value;
                                                                            }).name : this.state.templateName,
                                                                            avatar: this.state.selectorIndex ? this.state.selectorIndex + 1 : '1'
                                                                        } : '',
                                                                        options: this.state.allSig || this.state.allSig === undefined || !this.state.allSig ? this.state.allSig.map(function (d, index) {
                                                                            return {
                                                                                value: d.id || '0',
                                                                                label: d.name || _this10.state.templateName,
                                                                                avatar: (index + 1).toString() || '0'
                                                                            };
                                                                        }) : options.map(function (option) {
                                                                            return { value: option, label: option };
                                                                        }),
                                                                        onChange: function onChange(selectedOption) {
                                                                            var event = { target: { value: selectedOption.value } };
                                                                            _this10.onChange(event);
                                                                        },
                                                                        getOptionLabel: function getOptionLabel(option) {
                                                                            return option.avatar ? React.createElement(
                                                                                'div',
                                                                                { style: { display: 'flex', alignItems: 'center' } },
                                                                                React.createElement(
                                                                                    ListItemAvatar,
                                                                                    { sx: { minWidth: '33px' } },
                                                                                    React.createElement(
                                                                                        Avatar,
                                                                                        { sx: { width: 25, height: 25, fontSize: '13px', backgroundColor: '#1F6BF1', color: '#fff' } },
                                                                                        option.avatar
                                                                                    )
                                                                                ),
                                                                                React.createElement(
                                                                                    'span',
                                                                                    null,
                                                                                    option.label
                                                                                )
                                                                            ) : option.label;
                                                                        },
                                                                        getValueLabel: function getValueLabel(value) {
                                                                            return value.avatar ? React.createElement(
                                                                                'div',
                                                                                { style: { display: 'flex', alignItems: 'center' } },
                                                                                React.createElement(
                                                                                    ListItemAvatar,
                                                                                    { sx: { minWidth: '33px' } },
                                                                                    React.createElement(
                                                                                        Avatar,
                                                                                        { sx: { width: 25, height: 25, fontSize: '13px', backgroundColor: '#1F6BF1', color: '#fff' } },
                                                                                        value.avatar
                                                                                    )
                                                                                ),
                                                                                React.createElement(
                                                                                    'span',
                                                                                    null,
                                                                                    value.label
                                                                                )
                                                                            ) : value.label;
                                                                        },
                                                                        components: {
                                                                            DropdownIndicator: DropdownIndicator
                                                                        },
                                                                        styles: {
                                                                            control: function control(provided) {
                                                                                return Object.assign({}, provided, {
                                                                                    fontSize: '1.2rem'
                                                                                });
                                                                            },
                                                                            option: function option(provided) {
                                                                                return Object.assign({}, provided, {
                                                                                    fontSize: '1.2rem'
                                                                                });
                                                                            },
                                                                            menu: function menu(provided) {
                                                                                return Object.assign({}, provided, {
                                                                                    zIndex: 999
                                                                                });
                                                                            }
                                                                        }
                                                                    })
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            'div',
                                                            { style: { display: 'flex' } },
                                                            this.state.allSig && this.state.allSig.length < 10 && React.createElement(
                                                                Button,
                                                                {
                                                                    variant: 'outlined',
                                                                    color: 'primary',
                                                                    onClick: function onClick() {
                                                                        return _this10.addNewTemplate();
                                                                    },
                                                                    style: { marginRight: '10px', marginTop: '10px' },
                                                                    sx: {
                                                                        color: '#1F6BF1',
                                                                        borderColor: '#1F6BF1',
                                                                        '&:hover': {
                                                                            backgroundColor: 'white',
                                                                            color: 'success',
                                                                            borderColor: 'success'
                                                                        },
                                                                        '& .MuiButton-label': {
                                                                            fontSize: '1rem'
                                                                        }
                                                                    }
                                                                },
                                                                'New ',
                                                                this.state.width > 391 ? 'Signature' : ''
                                                            ),
                                                            this.state.width < 991 && isShowingPreviewMobile ? React.createElement(
                                                                Button,
                                                                {
                                                                    disableRipple: true,
                                                                    variant: 'contained',
                                                                    color: 'primary',
                                                                    onClick: function onClick() {
                                                                        return _this10.showPreviewMobile();
                                                                    },
                                                                    style: { marginRight: '10px', marginTop: '10px' },
                                                                    sx: {
                                                                        color: '#fff',
                                                                        backgroundColor: '#1F6BF1',
                                                                        '&:hover': {
                                                                            backgroundColor: '#1F6BF1',
                                                                            color: '#fff'
                                                                        }
                                                                    }
                                                                },
                                                                this.state.width > 303 ? 'Preview' : '',
                                                                ' ',
                                                                React.createElement(VisibilityOffIcon, { style: this.state.width > 303 ? { marginLeft: '10px' } : {} })
                                                            ) : this.state.width < 992 && !isShowingPreviewMobile ? React.createElement(
                                                                Button,
                                                                {
                                                                    disableRipple: true,
                                                                    variant: 'contained',
                                                                    color: 'primary',
                                                                    onClick: function onClick() {
                                                                        return _this10.showPreviewMobile();
                                                                    },
                                                                    style: { marginRight: '10px', marginTop: '10px' },
                                                                    sx: {
                                                                        color: '#fff',
                                                                        backgroundColor: '#1F6BF1',
                                                                        '&:hover': {
                                                                            backgroundColor: '#1F6BF1',
                                                                            color: '#fff'
                                                                        }
                                                                    }
                                                                },
                                                                this.state.width > 303 ? 'Preview' : '',
                                                                ' ',
                                                                React.createElement(VisibilityIcon, { style: this.state.width > 303 ? { marginLeft: '10px' } : {} })
                                                            ) : '',
                                                            this.state.allSig !== undefined && this.state.allSig.length > 1 ? React.createElement(
                                                                'div',
                                                                { style: { position: 'relative', marginTop: '15px', marginRight: '10px' } },
                                                                React.createElement(MoreHorizIcon, { className: 'more-icon', style: { cursor: 'pointer' }, onClick: this.toggleMenu }),
                                                                isMenuOpen && React.createElement(
                                                                    'div',
                                                                    { className: 'dropdown-menu' },
                                                                    React.createElement(
                                                                        'div',
                                                                        { className: 'delete-icon' },
                                                                        React.createElement(
                                                                            Button,
                                                                            {
                                                                                onClick: function onClick() {
                                                                                    return _this10.deleteData();
                                                                                },
                                                                                variant: 'contained',
                                                                                color: 'secondary',
                                                                                size: 'small',
                                                                                style: {
                                                                                    color: '#fff'
                                                                                }
                                                                            },
                                                                            'Delete'
                                                                        )
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    'style',
                                                                    null,
                                                                    '\n                                                                                .dropdown-menu {\n                                                                                    position: absolute;\n                                                                                    top: 33px;\n                                                                                    right: -23px;\n                                                                                    background-color: transparent;\n                                                                                    border-radius: 5px;\n                                                                                    padding: 0px;\n                                                                                    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n                                                                                    z-index: 9999;\n                                                                                  }\n                                                                                '
                                                                )
                                                            ) : ''
                                                        )
                                                    ),
                                                    this.state.newTemplate && React.createElement(
                                                        Grid,
                                                        { item: true, container: true, direction: 'row', lg: 6, md: 12, sm: 12, xs: 12, style: { display: 'flex', alignItems: 'center' } },
                                                        React.createElement(
                                                            'div',
                                                            { style: { marginRight: '10px', marginTop: '10px' } },
                                                            React.createElement(
                                                                Grid,
                                                                { style: { display: 'flex', justifyContent: 'left' } },
                                                                React.createElement(
                                                                    FormGroup,
                                                                    null,
                                                                    React.createElement(TextField, { label: 'Signature name', InputLabelProps: { shrink: true }, placeholder: 'Business signature', maxLength: 35, value: this.state.templateName, onChange: this.onCreateTemplate.bind(this), type: 'text', name: 'sigName', id: 'sigNameForm' })
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            'div',
                                                            { style: { display: 'flex', marginTop: '10px' } },
                                                            React.createElement(
                                                                Grid,
                                                                { style: { display: 'flex', justifyContent: 'space-evenly' } },
                                                                this.state.templateName !== undefined && this.state.templateName !== '' && !this.state.countryCodeTooltip ? React.createElement(
                                                                    Button,
                                                                    {
                                                                        variant: 'outlined',
                                                                        color: 'primary',
                                                                        onClick: function onClick() {
                                                                            return _this10.createNewTemplate();
                                                                        },
                                                                        style: { marginRight: '10px' },
                                                                        sx: {
                                                                            color: '#1F6BF1',
                                                                            borderColor: '#1F6BF1',
                                                                            '&:hover': {
                                                                                backgroundColor: 'white',
                                                                                color: 'success',
                                                                                borderColor: 'success'
                                                                            },
                                                                            '& .MuiButton-label': {
                                                                                fontSize: '1rem'
                                                                            }
                                                                        }
                                                                    },
                                                                    'Save'
                                                                ) : '',
                                                                React.createElement(
                                                                    Button,
                                                                    {
                                                                        variant: 'outlined',
                                                                        color: 'secondary',
                                                                        onClick: function onClick() {
                                                                            return _this10.cancelAddNewTemplate();
                                                                        },
                                                                        style: { marginRight: '10px' },
                                                                        sx: {
                                                                            color: 'red',
                                                                            borderColor: 'red',
                                                                            '&:hover': {
                                                                                backgroundColor: 'white'
                                                                            },
                                                                            '& .MuiButton-label': {
                                                                                fontSize: '1rem'
                                                                            }
                                                                        }
                                                                    },
                                                                    'Cancel'
                                                                )
                                                            )
                                                        )
                                                    )
                                                ),
                                                (this.state.noUserData || this.state.allSig === undefined) && React.createElement(
                                                    FormGroup,
                                                    null,
                                                    React.createElement(
                                                        Grid,
                                                        { item: true, container: true, direction: 'row', lg: 6, md: 12, sm: 12, xs: 12, style: { display: 'flex', alignItems: 'center' } },
                                                        React.createElement(
                                                            'div',
                                                            { style: { marginRight: '10px', marginTop: '10px' } },
                                                            React.createElement(
                                                                Grid,
                                                                { style: { display: 'flex', justifyContent: 'left' } },
                                                                React.createElement(
                                                                    FormControl,
                                                                    null,
                                                                    React.createElement(TextField, {
                                                                        disableUnderline: true, placeholder: 'Business signature',
                                                                        variant: 'outlined',
                                                                        InputLabelProps: { shrink: true },
                                                                        maxLength: 35,
                                                                        label: this.state.noUserData ? 'Create new Signature:' : 'Signature name:',
                                                                        value: this.state.templateName,
                                                                        onChange: this.onCreateTemplate.bind(this),
                                                                        type: 'text', name: 'sigName', id: 'sigNameForm' })
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            'div',
                                                            { style: { display: 'flex', marginTop: '10px' } },
                                                            this.state.templateName !== undefined && this.state.templateName !== '' && !this.state.countryCodeTooltip ? React.createElement(
                                                                Grid,
                                                                { style: { display: 'flex', justifyContent: 'center' } },
                                                                React.createElement(
                                                                    Button,
                                                                    {
                                                                        variant: 'outlined',
                                                                        color: 'primary',
                                                                        onClick: function onClick() {
                                                                            return _this10.createNewTemplate();
                                                                        },
                                                                        sx: {
                                                                            color: '#1F6BF1',
                                                                            borderColor: '#1F6BF1',
                                                                            '&:hover': {
                                                                                backgroundColor: 'white',
                                                                                color: 'success',
                                                                                borderColor: 'success'
                                                                            },
                                                                            '& .MuiButton-label': {
                                                                                fontSize: '1rem'
                                                                            }
                                                                        }
                                                                    },
                                                                    'Save'
                                                                )
                                                            ) : ''
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            Grid,
                            { item: true, container: true, direction: 'row', lg: 12, md: 12, sm: 12, xs: 12 },
                            React.createElement(ScrollableTabsButtonAuto, { selectedTabValue: selectedTabValue, handleItemClick: this.handleItemClick })
                        ),
                        React.createElement(
                            Grid,
                            { item: true, container: true, direction: 'row', lg: 12, md: 12, sm: 12, xs: 12 },
                            React.createElement(
                                Grid,
                                { item: true, xl: 6, lg: 6, md: 12, sm: 12, xs: 12, style: this.state.width < 992 && isShowingPreviewMobile ? hiddenElementStyle : {} },
                                React.createElement(
                                    UserData,
                                    null,
                                    React.createElement(
                                        'div',
                                        { innerRef: function innerRef(input) {
                                                return _this10.formRef = input;
                                            } },
                                        React.createElement(
                                            Grid,
                                            { item: true, lg: 6, md: 12, xs: 12, style: { maxWidth: '100%' } },
                                            React.createElement(
                                                Grid,
                                                { item: true, lg: 12, md: 12, xs: 12 },
                                                React.createElement(
                                                    'div',
                                                    { innerRef: function innerRef(input) {
                                                            return _this10.formRef = input;
                                                        } },
                                                    React.createElement(
                                                        Hide,
                                                        null,
                                                        React.createElement(Input, { hidden: true, value: this.state.values.template = this.state.selectedTemplate, type: 'text', name: 'template', id: 'templateForm' })
                                                    ),
                                                    this.state.selectedTabValue === 0 && React.createElement(
                                                        AlignContent,
                                                        null,
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Name', variant: 'outlined', inputProps: { maxLength: 40 }, onChange: this.handleChange.bind(this), value: this.state.values.name, type: 'text', name: 'name', id: 'nameForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Title', variant: 'outlined', inputProps: { maxLength: 40 }, onChange: this.handleChange.bind(this), type: 'text', value: this.state.values.title, name: 'title', id: 'titleForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Address', variant: 'outlined', inputProps: { maxLength: 80 }, onChange: this.handleChange.bind(this), type: 'text', value: this.state.values.address, name: 'address', id: 'addressForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Mobile', variant: 'outlined', inputProps: { maxLength: 40, onInput: this.handleInputChange.bind(this) }, onChange: this.handleChange.bind(this), type: 'text', value: this.state.values.mobile, name: 'mobile', id: 'mobileForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Telephone', variant: 'outlined', inputProps: { maxLength: 40, onInput: this.handleInputChange.bind(this) }, onChange: this.handleChange.bind(this), type: 'text', value: this.state.values.telephone, name: 'telephone', id: 'telephoneForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Website', variant: 'outlined', inputProps: { maxLength: 40 }, invalid: this.state.validWebsiteURL, onChange: this.handleChange.bind(this), value: this.state.values.website, name: 'website', id: 'websiteForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Email', variant: 'outlined', inputProps: { maxLength: 50 }, invalid: this.state.validEmail, onChange: this.handleChange.bind(this), type: 'email', value: this.state.values.email, name: 'email', id: 'emailForm' })
                                                            )
                                                        )
                                                    ),
                                                    this.state.selectedTabValue === 1 && React.createElement(
                                                        AlignContent,
                                                        null,
                                                        React.createElement(
                                                            Grid,
                                                            { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                            React.createElement(
                                                                AlignForm,
                                                                { style: { width: '100%', position: 'relative' } },
                                                                React.createElement(
                                                                    FormGroup,
                                                                    null,
                                                                    !this.state.values.picture_base64 && React.createElement(TextField, {
                                                                        variant: 'outlined',
                                                                        label: '',
                                                                        InputLabelProps: { shrink: true },
                                                                        inputProps: { accept: ".png,.jpeg,.jpg" },
                                                                        id: 'file-input-image',
                                                                        type: 'file',
                                                                        accept: 'image/*',
                                                                        onClick: this.remAlert,
                                                                        onChange: function onChange(e) {
                                                                            return _this10.handleChange(e.target.files[0]);
                                                                        },
                                                                        name: 'picture_base64'
                                                                    }),
                                                                    this.state.values.picture_base64 && React.createElement(AvatarEditor, {
                                                                        border: 2,
                                                                        ref: function ref(_ref5) {
                                                                            return _this10.editorRef = _ref5;
                                                                        },
                                                                        image: this.state.values.picture_base64,
                                                                        width: 250,
                                                                        height: 250,
                                                                        scale: this.state.scale,
                                                                        position: this.state.position,
                                                                        onPositionChange: function onPositionChange(position) {
                                                                            return _this10.setState({ position: position });
                                                                        },
                                                                        style: { margin: '25px auto' }
                                                                    }),
                                                                    this.state.values.picture_base64 && React.createElement('img', { id: 'rem-picture', style: { width: '30px', position: 'absolute', top: '-10px' }, onClick: this.removePicture.bind(this), src: closeCircleImg, alt: 'cancel btn circle' })
                                                                )
                                                            ),
                                                            React.createElement(
                                                                Design,
                                                                null,
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                    this.state.values.picture_base64 && React.createElement(
                                                                        Grid,
                                                                        { item: true, lg: 5, md: 5, xs: 12 },
                                                                        React.createElement(
                                                                            'p',
                                                                            null,
                                                                            'Scale'
                                                                        )
                                                                    ),
                                                                    this.state.values.picture_base64 && React.createElement(
                                                                        Grid,
                                                                        { item: true, lg: 7, md: 7, xs: 12, style: { margin: 'auto' } },
                                                                        React.createElement(
                                                                            FormGroup,
                                                                            null,
                                                                            React.createElement(Input, {
                                                                                sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                disableUnderline: true,
                                                                                id: 'scale-input',
                                                                                type: 'range',
                                                                                min: '1',
                                                                                max: '5',
                                                                                step: '0.1',
                                                                                inputProps: { min: 1, max: 5, step: 0.1 },
                                                                                value: this.state.scale,
                                                                                onChange: this.handleScaleChange
                                                                            })
                                                                        )
                                                                    ),
                                                                    this.state.values.picture_base64 && React.createElement(
                                                                        Grid,
                                                                        { item: true, lg: 5, md: 5, xs: 12 },
                                                                        React.createElement(
                                                                            'p',
                                                                            null,
                                                                            'Crop image'
                                                                        )
                                                                    ),
                                                                    this.state.values.picture_base64 && React.createElement(
                                                                        Grid,
                                                                        { item: true, lg: 7, md: 7, xs: 12, style: { margin: 'auto' } },
                                                                        React.createElement(
                                                                            Button,
                                                                            { style: { background: '#1F6BF1' }, variant: 'contained', onClick: this.handleSetNewValue },
                                                                            'Crop'
                                                                        )
                                                                    ),
                                                                    React.createElement(
                                                                        Grid,
                                                                        { item: true, lg: 5, md: 5, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                        React.createElement(
                                                                            'p',
                                                                            null,
                                                                            'Image width'
                                                                        )
                                                                    ),
                                                                    React.createElement(
                                                                        Grid,
                                                                        { item: true, lg: 7, md: 7, xs: 12, style: { margin: 'auto' } },
                                                                        React.createElement(
                                                                            FormGroup,
                                                                            null,
                                                                            React.createElement('input', {
                                                                                sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                disableUnderline: true,
                                                                                type: 'range',
                                                                                min: 25,
                                                                                max: 113,
                                                                                name: 'size',
                                                                                value: this.state.values.size ? this.state.values.size : '60',
                                                                                onChange: this.handleChange.bind(this)
                                                                            })
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        ),
                                                        !this.state.values.picture_base64 && React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, variant: 'outlined', label: 'Image link', invalid: this.state.validImageURL, value: this.state.values.picture_link, onChange: this.handleChange.bind(this), type: 'text', name: 'picture_link', id: 'pictureLinkForm' }),
                                                                React.createElement('br', null),
                                                                this.state.validImageURLAlert && React.createElement(
                                                                    Alert,
                                                                    { severity: 'error' },
                                                                    'No image found. Please check link and try again.'
                                                                )
                                                            )
                                                        ),
                                                        this.state.values.picture_base64 && React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, disabled: true, variant: 'outlined', label: 'Image link', invalid: this.state.validImageURL, value: this.state.values.picture_link, onChange: this.handleChange.bind(this), type: 'text', name: 'picture_link', id: 'pictureLinkForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                this.state.imgFormat && React.createElement(
                                                                    Alert,
                                                                    { severity: 'error' },
                                                                    'Image type error. Allowed image format: .png, .jpeg or .jpg.'
                                                                ),
                                                                this.state.imgSize && React.createElement(
                                                                    Alert,
                                                                    { severity: 'error' },
                                                                    'Image max size is 2MB. Please choose a different one and try again.'
                                                                )
                                                            )
                                                        )
                                                    ),
                                                    this.state.selectedTabValue === 2 && React.createElement(
                                                        AlignContent,
                                                        null,
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'LinkedIn', variant: 'outlined', inputProps: { maxLength: 50 }, value: this.state.values.linkedin, onChange: this.handleChange.bind(this), type: 'text', name: 'linkedin', id: 'linkedinForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Facebook', variant: 'outlined', inputProps: { maxLength: 50 }, value: this.state.values.facebook, onChange: this.handleChange.bind(this), type: 'text', name: 'facebook', id: 'facebookForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Twitter', variant: 'outlined', inputProps: { maxLength: 50 }, value: this.state.values.twitterLink, onChange: this.handleChange.bind(this), type: 'text', name: 'twitterLink', id: 'twitterLinkForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            { style: { display: 'flex' } },
                                                            React.createElement(
                                                                FormGroup,
                                                                { style: { maxWidth: '111px', minWidth: '111px', position: 'relative' } },
                                                                this.state.countryCodeTooltip && React.createElement(
                                                                    Tooltip,
                                                                    { style: { position: 'absolute', width: '146px' }, placement: 'top' },
                                                                    React.createElement(
                                                                        'span',
                                                                        null,
                                                                        React.createElement(
                                                                            Button,
                                                                            { style: { fontSize: '9px', color: 'red' }, disabled: true },
                                                                            'Country code required'
                                                                        )
                                                                    )
                                                                ),
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        borderRight: 'none',
                                                                        borderTopRightRadius: '0',
                                                                        borderBottomRightRadius: '0',
                                                                        "& fieldset": {
                                                                            borderRight: 'none',
                                                                            borderTopRightRadius: '0',
                                                                            borderBottomRightRadius: '0'
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Country Code', variant: 'outlined', InputLabelProps: { shrink: true }, inputProps: { maxLength: 4, onInput: this.handleInputChange.bind(this) }, onChange: this.handleChange.bind(this), type: 'text', value: this.state.values.phoneCode !== undefined && this.state.values.phoneCode !== "" ? this.state.values.phoneCode : this.state.phoneCode, name: 'phoneCode', id: 'phoneCodeForm' })
                                                            ),
                                                            React.createElement(
                                                                FormGroup,
                                                                { style: { width: '100%' } },
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        borderLeft: 'none',
                                                                        borderTopLeftRadius: '0',
                                                                        borderBottomLeftRadius: '0',
                                                                        "& fieldset": {
                                                                            borderLeft: 'none',
                                                                            borderTopLeftRadius: '0',
                                                                            borderBottomLeftRadius: '0'
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'WhatsApp', variant: 'outlined', inputProps: { maxLength: 40, onInput: this.handleInputChange.bind(this) }, onChange: this.handleChange.bind(this), type: 'text', value: this.state.values.whatsapp, name: 'whatsapp', id: 'whatsappForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'TikTok', variant: 'outlined', inputProps: { maxLength: 50 }, value: this.state.values.tiktok, onChange: this.handleChange.bind(this), type: 'text', name: 'tiktok', id: 'tiktokForm' })
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                FormGroup,
                                                                null,
                                                                React.createElement(TextField, { sx: {
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                fontWeight: 'light',
                                                                                color: 'grey'
                                                                            }
                                                                        },
                                                                        "& label.Mui-focused": {
                                                                            color: "rgb(31, 107, 241)"
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "rgb(31, 107, 241)"
                                                                            }
                                                                        }
                                                                    }, label: 'Instagram', variant: 'outlined', inputProps: { maxLength: 50 }, value: this.state.values.instagramLink, onChange: this.handleChange.bind(this), type: 'text', name: 'instagramLink', id: 'instagramLinkkForm' })
                                                            )
                                                        )
                                                    ),
                                                    this.state.selectedTabValue === 3 && React.createElement(
                                                        AlignContent,
                                                        null,
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Font Family'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12 },
                                                                    React.createElement(SelectFontFamily, {
                                                                        value: this.state.values.activeFontFamily = this.state.activeFontFamily !== undefined ? this.state.activeFontFamily : this.state.values.activeFontFamily,
                                                                        onChange: this.handleChange.bind(this),
                                                                        onFontChange: this.handleFontChange,
                                                                        defaultValue: this.state.activeFontFamily !== undefined ? this.state.activeFontFamily : this.state.values.activeFontFamily })
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: { display: 'flex', alignItems: 'center' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Name Design'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, container: true, direction: 'row', lg: 8, md: 9, xs: 12, style: { display: 'block', margin: 'auto' } },
                                                                    !this.state.isNameVisible && React.createElement(
                                                                        'div',
                                                                        { style: { display: 'flex', alignItems: 'center' } },
                                                                        React.createElement(
                                                                            'p',
                                                                            { style: { marginRight: '10px' } },
                                                                            'Expand Name Section'
                                                                        ),
                                                                        React.createElement(
                                                                            Tooltip,
                                                                            { title: React.createElement(
                                                                                    React.Fragment,
                                                                                    null,
                                                                                    React.createElement('img', {
                                                                                        src: nameTooltip,
                                                                                        alt: 'Expand Address',
                                                                                        style: { maxWidth: '100%', height: 'auto' }
                                                                                    })
                                                                                ),
                                                                                TransitionComponent: Zoom,
                                                                                arrow: true, placement: 'right' },
                                                                            React.createElement(ExpandIcon, {
                                                                                sx: {
                                                                                    color: '#1F6BF1',
                                                                                    cursor: 'pointer',
                                                                                    transition: 'transform 0.3s ease-in-out',
                                                                                    '&:hover': {
                                                                                        transform: 'scale(1.2)'
                                                                                    }
                                                                                },
                                                                                onClick: this.toggleNameVisibility
                                                                            })
                                                                        )
                                                                    ),
                                                                    this.state.isNameVisible && React.createElement(
                                                                        'div',
                                                                        null,
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '9px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Size'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement('input', { id: 'fontSizeName',
                                                                                    sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                    disableUnderline: true,
                                                                                    style: { width: '100%' },
                                                                                    type: 'range',
                                                                                    min: '11',
                                                                                    name: 'fontSizeName',
                                                                                    max: '17',
                                                                                    value: this.state.values.fontSizeName ? this.state.values.fontSizeName : '11',
                                                                                    onChange: this.handleChange.bind(this)
                                                                                })
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '9px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Line Height'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement('input', { id: 'lineHeightName',
                                                                                    sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                    disableUnderline: true,
                                                                                    style: { width: '100%' },
                                                                                    type: 'range',
                                                                                    min: '22',
                                                                                    name: 'fontLineHeightName',
                                                                                    max: '34',
                                                                                    value: this.state.values.fontLineHeightName ? this.state.values.fontLineHeightName : '22',
                                                                                    onChange: this.handleChange.bind(this)
                                                                                })
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '6px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Color'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement(
                                                                                    Hide,
                                                                                    null,
                                                                                    React.createElement(Input, { type: 'text',
                                                                                        value: this.state.values.selectedColorName ? this.state.values.selectedColorName : "#000000",
                                                                                        onChange: this.handleChange.bind(this),
                                                                                        readOnly: true })
                                                                                ),
                                                                                this.renderColorPickerName()
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Style'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'div',
                                                                                    { style: { display: 'flex', justifyContent: 'left' } },
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', paddingLeft: '0', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: 'normal',
                                                                                            checked: this.state.values.fontStyleName === 'normal',
                                                                                            onChange: this.handleFontStyleChange }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Normal'
                                                                                        )
                                                                                    ),
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: 'italic',
                                                                                            checked: this.state.values.fontStyleName === 'italic',
                                                                                            onChange: this.handleFontStyleChange }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Italic'
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Weight'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'div',
                                                                                    { style: { display: 'flex', justifyContent: 'left' } },
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', paddingLeft: '0', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: '400',
                                                                                            checked: this.state.values.fontWeightName === '400',
                                                                                            onChange: this.handleFontWeightChange }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Normal'
                                                                                        )
                                                                                    ),
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: '700',
                                                                                            checked: this.state.values.fontWeightName === '700',
                                                                                            onChange: this.handleFontWeightChange }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Bold'
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: { display: 'flex', alignItems: 'center' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Title Design'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, container: true, direction: 'row', lg: 8, md: 9, xs: 12, style: { display: 'block', margin: 'auto' } },
                                                                    !this.state.isTitleVisible && React.createElement(
                                                                        'div',
                                                                        { style: { display: 'flex', alignItems: 'center' } },
                                                                        React.createElement(
                                                                            'p',
                                                                            { style: { marginRight: '10px' } },
                                                                            'Expand Title Section'
                                                                        ),
                                                                        React.createElement(
                                                                            Tooltip,
                                                                            { title: React.createElement(
                                                                                    React.Fragment,
                                                                                    null,
                                                                                    React.createElement('img', {
                                                                                        src: titleTooltip,
                                                                                        alt: 'Expand Address',
                                                                                        style: { maxWidth: '100%', height: 'auto' }
                                                                                    })
                                                                                ),
                                                                                TransitionComponent: Zoom,
                                                                                arrow: true, placement: 'right' },
                                                                            React.createElement(ExpandIcon, {
                                                                                sx: {
                                                                                    color: '#1F6BF1',
                                                                                    cursor: 'pointer',
                                                                                    transition: 'transform 0.3s ease-in-out',
                                                                                    '&:hover': {
                                                                                        transform: 'scale(1.2)'
                                                                                    }
                                                                                },
                                                                                onClick: this.toggleTitleVisibility
                                                                            })
                                                                        )
                                                                    ),
                                                                    this.state.isTitleVisible && React.createElement(
                                                                        'div',
                                                                        null,
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '9px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Size'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement('input', { id: 'fontSize',
                                                                                    sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                    disableUnderline: true,
                                                                                    style: { width: '100%' },
                                                                                    type: 'range',
                                                                                    min: '11',
                                                                                    name: 'fontSizeTitle',
                                                                                    max: '17',
                                                                                    value: this.state.values.fontSizeTitle ? this.state.values.fontSizeTitle : '11',
                                                                                    onChange: this.handleChange.bind(this)
                                                                                })
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '9px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Line Height'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement('input', { id: 'lineHeighTitle',
                                                                                    sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                    disableUnderline: true,
                                                                                    style: { width: '100%' },
                                                                                    type: 'range',
                                                                                    min: '22',
                                                                                    name: 'fontLineHeightTitle',
                                                                                    max: '34',
                                                                                    value: this.state.values.fontLineHeightTitle ? this.state.values.fontLineHeightTitle : '22',
                                                                                    onChange: this.handleChange.bind(this)
                                                                                })
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '6px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Color'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement(
                                                                                    Hide,
                                                                                    null,
                                                                                    React.createElement(Input, { type: 'text',
                                                                                        value: this.state.values.selectedColorTitle ? this.state.values.selectedColorTitle : '#000000',
                                                                                        onChange: this.handleChange.bind(this),
                                                                                        readOnly: true })
                                                                                ),
                                                                                this.renderColorPickerTitle()
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Style'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'div',
                                                                                    { style: { display: 'flex', justifyContent: 'left' } },
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', paddingLeft: '0', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: 'normal',
                                                                                            checked: this.state.values.fontStyleTitle === 'normal',
                                                                                            onChange: this.handleFontStyleChangeTitle }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Normal'
                                                                                        )
                                                                                    ),
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: 'italic',
                                                                                            checked: this.state.values.fontStyleTitle === 'italic',
                                                                                            onChange: this.handleFontStyleChangeTitle }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Italic'
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Weight'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'div',
                                                                                    { style: { display: 'flex', justifyContent: 'left' } },
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', paddingLeft: '0', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: '400',
                                                                                            checked: this.state.values.fontWeightTitle === '400',
                                                                                            onChange: this.handleFontWeightChangeTitle }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Normal'
                                                                                        )
                                                                                    ),
                                                                                    React.createElement(
                                                                                        'label',
                                                                                        { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                                                                        React.createElement(Checkbox, {
                                                                                            sx: { border: 'none', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                                            disableUnderline: true,
                                                                                            type: 'checkbox',
                                                                                            value: '700',
                                                                                            checked: this.state.values.fontWeightTitle === '700',
                                                                                            onChange: this.handleFontWeightChangeTitle }),
                                                                                        React.createElement(
                                                                                            'p',
                                                                                            null,
                                                                                            'Bold'
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: { display: 'flex', alignItems: 'center' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Address Design'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, container: true, direction: 'row', lg: 8, md: 9, xs: 12, style: { display: 'block', margin: 'auto' } },
                                                                    !this.state.isAddressVisible && React.createElement(
                                                                        'div',
                                                                        { style: { display: 'flex', alignItems: 'center' } },
                                                                        React.createElement(
                                                                            'p',
                                                                            { style: { marginRight: '10px' } },
                                                                            'Expand Address Section'
                                                                        ),
                                                                        React.createElement(
                                                                            Tooltip,
                                                                            { title: React.createElement(
                                                                                    React.Fragment,
                                                                                    null,
                                                                                    React.createElement('img', {
                                                                                        src: addressTooltip,
                                                                                        alt: 'Expand Address',
                                                                                        style: { maxWidth: '100%', height: 'auto' }
                                                                                    })
                                                                                ),
                                                                                TransitionComponent: Zoom,
                                                                                arrow: true, placement: 'right' },
                                                                            React.createElement(ExpandIcon, {
                                                                                sx: {
                                                                                    color: '#1F6BF1',
                                                                                    cursor: 'pointer',
                                                                                    transition: 'transform 0.3s ease-in-out',
                                                                                    '&:hover': {
                                                                                        transform: 'scale(1.2)'
                                                                                    }
                                                                                },
                                                                                onClick: this.toggleAddressVisibility
                                                                            })
                                                                        )
                                                                    ),
                                                                    this.state.isAddressVisible && React.createElement(
                                                                        'div',
                                                                        null,
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '9px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Font Size'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement('input', { id: 'fontSize',
                                                                                    sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                    disableUnderline: true,
                                                                                    style: { width: '100%' },
                                                                                    type: 'range',
                                                                                    min: '11',
                                                                                    name: 'fontSizeAddress',
                                                                                    max: '17',
                                                                                    value: this.state.values.fontSizeAddress ? this.state.values.fontSizeAddress : '11',
                                                                                    onChange: this.handleChange.bind(this)
                                                                                })
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '9px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Text Opacity'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement('input', { id: 'addressTextOpacity',
                                                                                    sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                                    disableUnderline: true,
                                                                                    style: { width: '100%' },
                                                                                    type: 'range',
                                                                                    min: 0.3,
                                                                                    name: 'addressTextOpacity',
                                                                                    max: 1,
                                                                                    step: 0.01,
                                                                                    value: this.state.values.addressTextOpacity ? this.state.values.addressTextOpacity : '1',
                                                                                    onChange: this.handleChange.bind(this)
                                                                                })
                                                                            )
                                                                        ),
                                                                        React.createElement(
                                                                            Grid,
                                                                            { item: true, lg: 12, md: 12, xs: 12, style: { display: 'flex', padding: '6px 0' } },
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 4, md: 4, xs: 4, style: { display: 'block', margin: 'auto' } },
                                                                                React.createElement(
                                                                                    'p',
                                                                                    null,
                                                                                    'Color'
                                                                                )
                                                                            ),
                                                                            React.createElement(
                                                                                Grid,
                                                                                { item: true, lg: 8, md: 8, xs: 8, style: { margin: 'auto', lineHeight: '0' } },
                                                                                React.createElement(
                                                                                    Hide,
                                                                                    null,
                                                                                    React.createElement(Input, { type: 'text',
                                                                                        value: this.state.values.selectedColorAddress ? this.state.values.selectedColorAddress : '#000000',
                                                                                        onChange: this.handleChange.bind(this),
                                                                                        readOnly: true })
                                                                                ),
                                                                                this.renderColorPickerAddress()
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto', padding: '9px 0' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Info Font Size'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12, style: { margin: 'auto', lineHeight: '0' } },
                                                                    React.createElement('input', { id: 'fontSize',
                                                                        sx: { border: 'none', "& fieldset": { border: 'none' } },
                                                                        disableUnderline: true,
                                                                        style: { width: '100%' },
                                                                        type: 'range',
                                                                        min: '11',
                                                                        name: 'fontSize',
                                                                        max: '17',
                                                                        value: this.state.values.fontSize ? this.state.values.fontSize : '11',
                                                                        onChange: this.handleChange.bind(this)
                                                                    })
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Info Title Color'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12, style: { margin: 'auto', lineHeight: '0' } },
                                                                    React.createElement(
                                                                        Hide,
                                                                        null,
                                                                        React.createElement(Input, { hidden: true, type: 'text',
                                                                            value: this.state.selectedTemplateColor ? this.state.selectedTemplateColor : '#000000',
                                                                            onChange: this.handleChange.bind(this),
                                                                            readOnly: true })
                                                                    ),
                                                                    this.renderColorTemplatePicker()
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Info Text Color'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12, style: { margin: 'auto', lineHeight: '0' } },
                                                                    React.createElement(
                                                                        Hide,
                                                                        null,
                                                                        React.createElement(Input, { type: 'text',
                                                                            value: this.state.values.selectedColor ? this.state.values.selectedColor : '#000000',
                                                                            onChange: this.handleChange.bind(this),
                                                                            readOnly: true })
                                                                    ),
                                                                    this.renderColorPicker()
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Divider Color'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12, style: { margin: 'auto', lineHeight: '0' } },
                                                                    React.createElement(
                                                                        Hide,
                                                                        null,
                                                                        React.createElement(Input, { type: 'text',
                                                                            value: this.state.values.selectedColorDivider ? this.state.values.selectedColorDivider : '#000000',
                                                                            onChange: this.handleChange.bind(this),
                                                                            readOnly: true })
                                                                    ),
                                                                    this.renderColorPickerDivider()
                                                                )
                                                            )
                                                        ),
                                                        this.state.selectedTemplate == 6 && React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'Quote'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12, style: { margin: 'auto' } },
                                                                    React.createElement(
                                                                        FormGroup,
                                                                        null,
                                                                        React.createElement(TextField, { sx: {
                                                                                input: {
                                                                                    "&::placeholder": {
                                                                                        fontWeight: 'light',
                                                                                        color: 'grey'
                                                                                    }
                                                                                },
                                                                                "& label.Mui-focused": {
                                                                                    color: "rgb(31, 107, 241)"
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    "&.Mui-focused fieldset": {
                                                                                        borderColor: "rgb(31, 107, 241)"
                                                                                    }
                                                                                }
                                                                            }, variant: 'outlined', label: 'Write your personal Quote', inputProps: { maxLength: 250 }, value: this.state.values.quote, onChange: this.handleChange.bind(this), type: 'text', name: 'quote', id: 'quoteForm' })
                                                                    )
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 4, md: 3, xs: 12, style: this.state.width < 900 ? { marginBottom: '10px', display: 'block', margin: 'auto' } : { display: 'block', margin: 'auto' } },
                                                                    React.createElement(
                                                                        'p',
                                                                        null,
                                                                        'BlueMail Signature'
                                                                    )
                                                                ),
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 8, md: 9, xs: 12, style: { margin: 'auto' } },
                                                                    React.createElement(Checkbox, {
                                                                        sx: { border: 'none', color: '#1F6BF1!important', "& fieldset": { border: 'none' } },
                                                                        disableUnderline: true,
                                                                        id: 'blSignature',
                                                                        type: 'checkbox',
                                                                        onChange: this.handleCheck.bind(this),
                                                                        checked: this.state.values.checkSignature,
                                                                        name: 'blSignature' })
                                                                )
                                                            )
                                                        )
                                                    ),
                                                    this.state.selectedTabValue === 4 && React.createElement(
                                                        AlignContent,
                                                        null,
                                                        React.createElement(
                                                            AlignForm,
                                                            null,
                                                            React.createElement(
                                                                Grid,
                                                                { item: true, container: true, direction: 'row', lg: 12, md: 12, xs: 12 },
                                                                React.createElement(
                                                                    Grid,
                                                                    { item: true, lg: 12, md: 12, xs: 12, style: { margin: 'auto' } },
                                                                    React.createElement(StandardImageList, { currentIndex: this.state.values.currentIndex ? this.state.values.currentIndex : 0, handleImageClick: this.selectTemplate })
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            React.createElement(
                                Grid,
                                { item: true, xl: 6, lg: 6, md: 12, sm: 12, xs: 12, style: this.state.width < 992 && !isShowingPreviewMobile ? hiddenElementStyle : {} },
                                React.createElement(
                                    Preview,
                                    null,
                                    React.createElement(
                                        Grid,
                                        { item: true, lg: 12, md: 12, xs: 12 },
                                        React.createElement(
                                            List,
                                            null,
                                            React.createElement(
                                                ListItem,
                                                { style: { paddingLeft: '10px', paddingRight: '10px' } },
                                                React.createElement(
                                                    'table',
                                                    null,
                                                    React.createElement(
                                                        'tbody',
                                                        null,
                                                        noSignature && React.createElement(
                                                            'tr',
                                                            null,
                                                            React.createElement(
                                                                'td',
                                                                { align: 'center' },
                                                                React.createElement(
                                                                    'div',
                                                                    { id: 'signature' },
                                                                    React.createElement(Template, { selectedTemplate: this.state.selectedTemplate, values: values, validImageURL: this.state.validImageURL, validWebsiteURL: this.state.validWebsiteURL, validEmail: this.state.validEmail, fetchingTweets: fetchingTweets, fetchingInstagram: fetchingInstagram })
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        ),
                                        (this.state.values.quote === "" || this.state.quote === "") && this.state.selectedTemplate === '6' ? React.createElement(
                                            Alert,
                                            { sx: { m: '0 auto 20px', display: 'flex', padding: "0 10px", maxWidth: 'fit-content', justifyContent: 'center', color: "#fff" }, variant: 'filled', severity: 'info' },
                                            'Edit this Quote from "Design" section.'
                                        ) : ''
                                    )
                                ),
                                React.createElement(
                                    Grid,
                                    { item: true, lg: 12, md: 12, xs: 12, sx: { display: 'block', margin: '20px auto 30px', textAlign: 'center' } },
                                    this.state.templates && (this.state.noUserData !== undefined || this.state.allSig !== undefined) && React.createElement(
                                        'div',
                                        null,
                                        React.createElement(
                                            Button,
                                            { variant: 'contained', disabled: this.state.countryCodeTooltip ? this.state.countryCodeTooltip : '', style: this.state.countryCodeTooltip ? { background: '#fff', border: '1px solid #1F6BF1', opacity: 0.5, color: '#1F6BF1' } : { background: '#1F6BF1' }, onClick: function onClick() {
                                                    return _this10.updateTemplate();
                                                } },
                                            'Update Signature'
                                        ),
                                        this.state.values.fetchingError && React.createElement(
                                            'p',
                                            { style: { color: 'red', fontSize: '12px', float: 'right' } },
                                            'fetching information..'
                                        )
                                    )
                                )
                            )
                        ),
                        this.state.allSig && this.state.allSig.length >= 10 && React.createElement(
                            AlignContent,
                            null,
                            React.createElement(
                                AlignForm,
                                { style: { marginTop: '0' } },
                                React.createElement(
                                    Grid,
                                    { item: true, container: true, direction: 'row', lg: 12, md: 12, sm: 12, xs: 12, style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                                    React.createElement(
                                        Alert,
                                        { style: { fontSize: '13px' }, severity: 'warning' },
                                        'The maximum signatures number (10), allowed for your account has been reached.'
                                    )
                                )
                            )
                        )
                    )
                );
            }
        }
    }]);

    return Signature;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        noSignature: state.signature.no_signature || true,
        initialValues: state.signature.fields,
        htmlToExport: state.signature.signature,
        fetching: state.signature.fetching,
        error: state.signature.error,
        fetchingTweets: state.signature.fetchingTweets,
        fetchingInstagram: state.signature.fetchingInstagram,
        user: state.user,
        tweets: state.signature.tweets,
        instagramPost: state.signature.instagramPost
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSignature: fetchSignature,
        deleteSignature: deleteSignature,
        createNewTemplate: createNewTemplate,
        updateTemplate: updateTemplate,
        fetchTweets: fetchTweets,
        fetchInstagramLastPost: fetchInstagramLastPost
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Signature);


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/App.js